import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import { t } from 'ember-intl';
import AlertBanner from 'tio-ui/components/alert-banner';
import EmployeesCreateEmployee from 'tio-employee/components/employees/create-employee';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    model: EmployeeModel;
  };
}
const tmpl: TOC<S> = <template>
  <VStack>
    <PageHeader @title={{t "partner.employee.create_employee"}} @sticky={{false}}>
      <:breadcrumbs as |b|>
        <b.crumb @route="authenticated.admin.employees.index" @label="Employees" />
        <b.crumb @label={{t "partner.employee.create_employee"}} />
      </:breadcrumbs>
    </PageHeader>
    <AlertBanner @intent="info">
      {{t "partner.employee.alert_info" htmlSafe=true}}
    </AlertBanner>
    <EmployeesCreateEmployee @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
